/**
 * What an unnamed questionnaire draft displays. The backend stores it as the
 * title of every new draft and the workspace falls back to it, so it reaches
 * this flow from two directions. It is not a name anyone chose.
 */
export const UNTITLED_QUESTIONNAIRE_TITLE = "Untitled questionnaire";

/**
 * A candidate study name, or "" when it is empty or only the placeholder.
 *
 * The "Study name" field is filled once, when it is empty, and every later
 * value is kept. Letting the placeholder in there froze it: resume copied it
 * from the new draft, the debounced save wrote it back as the display name,
 * and the real title the first Build produced was never offered again.
 */
export function usableStudyName(value: string | null | undefined): string {
  const name = value?.trim() ?? "";
  return name === UNTITLED_QUESTIONNAIRE_TITLE ? "" : name;
}
